import {assoc, not} from 'ramda'

import {FormReducer} from 'state/reducers/form'

export const submitError: FormReducer = (state) => assoc('error', not(state.error), state)
